import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';

// Lazy load pages
const IPSHome = lazy(() => import('./pages/IPSHome'));
const IPSExplore = lazy(() => import('./pages/IPSExplore'));
const IPSSearch = lazy(() => import('./pages/IPSSearch'));
const IPSProperty = lazy(() => import('./pages/IPSProperty'));
const IPSArea = lazy(() => import('./pages/IPSArea'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const NotFound = lazy(() => import('./pages/NotFound'));

// Loading component - Minimal white design
const PageLoader = () => (
  <div className="min-h-screen bg-white flex items-center justify-center">
    <div className="w-10 h-10 border-2 border-black/10 border-t-black rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* Main routes */}
            <Route path="/" element={<IPSHome />} />
            <Route path="/explore" element={<IPSExplore />} />
            <Route path="/search" element={<IPSSearch />} />

            {/* Property routes - support both UUID and SEO slugs */}
            <Route path="/property/:slug" element={<IPSProperty />} />

            {/* Blog routes */}
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />

            {/* Area landing pages for SEO */}
            <Route path="/clifton" element={<IPSArea />} />
            <Route path="/camps-bay" element={<IPSArea />} />
            <Route path="/bantry-bay" element={<IPSArea />} />
            <Route path="/sea-point" element={<IPSArea />} />
            <Route path="/fresnaye" element={<IPSArea />} />
            <Route path="/green-point" element={<IPSArea />} />
            <Route path="/mouille-point" element={<IPSArea />} />
            <Route path="/three-anchor-bay" element={<IPSArea />} />
            <Route path="/va-waterfront" element={<IPSArea />} />
            <Route path="/bakoven" element={<IPSArea />} />

            {/* Legacy IPS routes - redirect */}
            <Route path="/ips" element={<Navigate to="/" replace />} />
            <Route path="/ips/search" element={<Navigate to="/search" replace />} />
            <Route path="/ips/property/:id" element={<Navigate to="/property/:id" replace />} />

            {/* 404 catch-all - must be last */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
